module.exports = __webpack_public_path__ + "d3b241932bf899741db7a6edbed9ff01.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-9.png
// module id = 2338
// module chunks = 0